// extracted by mini-css-extract-plugin
export var dropdownIcon = "_m8-6";
export var imgContainer = "_m8-3";
export var menuIcon = "_m8-5";
export var pillWrapper = "_m8-2";
export var pillsContainer = "_m8-1";
export var subscriptionCard = "_m8-0";
export var subscriptionLogo = "_m8-4";